import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    toggleSection(event) {
        const answeredYes = this.#toggledAnswerToYes(event);
        const section = document.getElementById("loss-claim-question");
        if (!section) return;

        if (!answeredYes) {
            this.#resetNumberOfClaimsCount(section);
            this.#resetLossClaimsCards();
        }

        section.querySelectorAll('input, textarea, select').forEach(field => {
            this.#applyFieldVisibility(field, answeredYes && this.#isFieldInVisibleCard(field));
        });
    }

    changeLossClaimsCount(event) {
        const count = event.target.value;
        const cardVisibility = { '1': [true, false, false], '2': [true, true, false], '3+': [true, true, true] };
        const visibility = cardVisibility[count] || [false, false, false];

        visibility.forEach((visible, i) => {
            const card = document.getElementById(`loss-claim-card-${i + 1}`);
            if (!card) return;
            card.classList.toggle('hidden', !visible);
            card.querySelectorAll('input, textarea, select').forEach(field => {
                this.#applyFieldVisibility(field, visible);
            });
        });
    }

    #toggledAnswerToYes(event) {
        return event.target.value === "true";
    }

    #isFieldInVisibleCard(field) {
        const card = field.closest('[id^="loss-claim-card-"]');
        return card ? !card.classList.contains('hidden') : true;
    }

    #resetNumberOfClaimsCount(section) {
        section.querySelector('select[name="losses[count]"]').value = '';
    }

    #resetLossClaimsCards() {
        [1, 2, 3].forEach(i => {
            const card = document.getElementById(`loss-claim-card-${i}`);
            if (card) card.classList.add('hidden');
        });
    }

    #applyFieldVisibility(field, visible) {
        field.required = visible;
        field.disabled = !visible;
        if (!visible && field.type !== 'hidden') field.value = '';
    }
}
